export default "__VITE_ASSET__DdKT0rDE__"